// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICheckDetailsDto,
  ICheckDetailsUpdateDto,
  ICopyFilesRequestDto,
  IDocumentFileUploadByLinkDto,
  IDocumentFileUploadByQrCodeDto,
  IDocumentFileUploadCompletionDto,
  IDocumentFilesUrlDto,
  IDocumentIdDto,
  IDocumentOneTimeLinkDto,
  IDocumentQrCodeDto,
  IErrorDto,
  IFileUrlsResponseDto,
  IGenericErrorDto,
  ILockboxClaimRepaymentDto,
  ILockboxDto,
  IMultipleRecordsDto,
  IOcrDetailsDto,
  IOcrDetailsRequestDto,
  IOcrDto,
  IOcrReceiptResponseDto,
  IOneTimeLinkPresignUrlRequestDto,
  IOneTimeLinkResponseDto,
  IPresignUrlRequestDto,
  IPresignUrlResponse,
  IProcessedReturnedChecksDto,
  IQrCodeDto,
  IQrCodePresignUrlRequestDto,
  IReceiptDocumentFileDto,
  IReceiptDto,
  IReceiptPatchDto,
  IReturnedCheckDecisionsDto,
  IReturnedItemsDto,
  IVendorDto,
} from '../models/index';
import {
    ICheckDetailsDtoFromJSON,
    ICheckDetailsDtoToJSON,
    ICheckDetailsUpdateDtoFromJSON,
    ICheckDetailsUpdateDtoToJSON,
    ICopyFilesRequestDtoFromJSON,
    ICopyFilesRequestDtoToJSON,
    IDocumentFileUploadByLinkDtoFromJSON,
    IDocumentFileUploadByLinkDtoToJSON,
    IDocumentFileUploadByQrCodeDtoFromJSON,
    IDocumentFileUploadByQrCodeDtoToJSON,
    IDocumentFileUploadCompletionDtoFromJSON,
    IDocumentFileUploadCompletionDtoToJSON,
    IDocumentFilesUrlDtoFromJSON,
    IDocumentFilesUrlDtoToJSON,
    IDocumentIdDtoFromJSON,
    IDocumentIdDtoToJSON,
    IDocumentOneTimeLinkDtoFromJSON,
    IDocumentOneTimeLinkDtoToJSON,
    IDocumentQrCodeDtoFromJSON,
    IDocumentQrCodeDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IFileUrlsResponseDtoFromJSON,
    IFileUrlsResponseDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    ILockboxClaimRepaymentDtoFromJSON,
    ILockboxClaimRepaymentDtoToJSON,
    ILockboxDtoFromJSON,
    ILockboxDtoToJSON,
    IMultipleRecordsDtoFromJSON,
    IMultipleRecordsDtoToJSON,
    IOcrDetailsDtoFromJSON,
    IOcrDetailsDtoToJSON,
    IOcrDetailsRequestDtoFromJSON,
    IOcrDetailsRequestDtoToJSON,
    IOcrDtoFromJSON,
    IOcrDtoToJSON,
    IOcrReceiptResponseDtoFromJSON,
    IOcrReceiptResponseDtoToJSON,
    IOneTimeLinkPresignUrlRequestDtoFromJSON,
    IOneTimeLinkPresignUrlRequestDtoToJSON,
    IOneTimeLinkResponseDtoFromJSON,
    IOneTimeLinkResponseDtoToJSON,
    IPresignUrlRequestDtoFromJSON,
    IPresignUrlRequestDtoToJSON,
    IPresignUrlResponseFromJSON,
    IPresignUrlResponseToJSON,
    IProcessedReturnedChecksDtoFromJSON,
    IProcessedReturnedChecksDtoToJSON,
    IQrCodeDtoFromJSON,
    IQrCodeDtoToJSON,
    IQrCodePresignUrlRequestDtoFromJSON,
    IQrCodePresignUrlRequestDtoToJSON,
    IReceiptDocumentFileDtoFromJSON,
    IReceiptDocumentFileDtoToJSON,
    IReceiptDtoFromJSON,
    IReceiptDtoToJSON,
    IReceiptPatchDtoFromJSON,
    IReceiptPatchDtoToJSON,
    IReturnedCheckDecisionsDtoFromJSON,
    IReturnedCheckDecisionsDtoToJSON,
    IReturnedItemsDtoFromJSON,
    IReturnedItemsDtoToJSON,
    IVendorDtoFromJSON,
    IVendorDtoToJSON,
} from '../models/index';

export interface CopyFilesFromDocumentsRequest {
    documentId: number;
    iCopyFilesRequestDto: ICopyFilesRequestDto;
}

export interface CreateDocumentByOneTimeLinkRequest {
    iDocumentOneTimeLinkDto: IDocumentOneTimeLinkDto;
}

export interface CreateDocumentByQrCodeRequest {
    iDocumentQrCodeDto: IDocumentQrCodeDto;
}

export interface CreateDraftReceiptRequest {
    iReceiptDto: IReceiptDto;
}

export interface CreateReceiptRequest {
    iReceiptDto: IReceiptDto;
}

export interface DeactivateOneTimeLinkRequest {
    hashId: string;
}

export interface DeleteDocumentRequest {
    documentId: number;
}

export interface DeleteDocumentFileRequest {
    fileId: number;
}

export interface DocumentFileImportByOneTimeLinkRequest {
    documentId: number;
    hashId: string;
    employeeId: number;
    file: Blob;
}

export interface DocumentFileImportByQrCodeRequest {
    documentId: number;
    qrId: string;
    employeeId: number;
    file: Blob;
}

export interface FileExistsRequest {
    fileId: number;
}

export interface FindOneTimeLinkRequest {
    hashId: string;
}

export interface GenerateQrCodeRequest {
    iDocumentIdDto?: IDocumentIdDto;
}

export interface GetClaimRepaymentLockboxByIdRequest {
    lockboxId: number;
}

export interface GetDocumentFilesUrlStreamRequest {
    qrId: string;
}

export interface GetDocumentIdByFileIdRequest {
    fileId: number;
}

export interface GetDocumentUrlDtoByDocumentIdRequest {
    documentId: number;
}

export interface GetDocumentsFilesUrlDtoByDocumentIdsRequest {
    documentIds: Set<number>;
}

export interface GetReceiptDocumentFilesRequest {
    receiptId: number;
}

export interface HandleDocumentFileImport1Request {
    documentId: number;
    file: Blob;
}

export interface HandleDocumentFileImportCompletionRequest {
    documentId: number;
    iDocumentFileUploadCompletionDto: IDocumentFileUploadCompletionDto;
}

export interface HandleDocumentFileImportCompletion1Request {
    documentId: number;
    iDocumentFileUploadByQrCodeDto: IDocumentFileUploadByQrCodeDto;
}

export interface HandleDocumentFileImportCompletion2Request {
    documentId: number;
    iDocumentFileUploadByLinkDto: IDocumentFileUploadByLinkDto;
}

export interface MatchFileWithOpenAiRequest {
    fileId: number;
    iOcrDto: IOcrDto;
}

export interface ParseFileWithOpenAiRequest {
    fileId: number;
    employeeId?: number;
    iOcrDto?: IOcrDto;
}

export interface PresignUploadUrlByOneTimeLinkRequest {
    documentId: number;
    iOneTimeLinkPresignUrlRequestDto: IOneTimeLinkPresignUrlRequestDto;
}

export interface PresignUploadUrlByQrCodeRequest {
    documentId: number;
    iQrCodePresignUrlRequestDto: IQrCodePresignUrlRequestDto;
}

export interface PresignUrlRequest {
    documentId: number;
    iPresignUrlRequestDto: IPresignUrlRequestDto;
}

export interface ProcessReturnedCheckDecisionsRequest {
    iReturnedCheckDecisionsDto: IReturnedCheckDecisionsDto;
}

export interface RetrieveLockboxesRequest {
    types?: Array<RetrieveLockboxesTypesEnum>;
    statuses?: Array<RetrieveLockboxesStatusesEnum>;
    searchValue?: string;
    paymentMethods?: Array<RetrieveLockboxesPaymentMethodsEnum>;
    wireStatuses?: Array<RetrieveLockboxesWireStatusesEnum>;
    ids?: Set<number>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface RetrieveOcrDetailsRequest {
    documentId: number;
    iOcrDetailsRequestDto?: IOcrDetailsRequestDto;
}

export interface RetrieveOcrDetails1Request {
    claimId: number;
}

export interface RetrieveReturnedItemsRequest {
    employeeId?: number;
}

export interface SearchDocumentForEmployeeWithIdRequest {
    documentId: number;
}

export interface SplitLockboxRequest {
    lockboxId: number;
    iMultipleRecordsDto: IMultipleRecordsDto;
}

export interface UpdateCheckDetailsRequest {
    lockboxId: number;
    iCheckDetailsUpdateDto: ICheckDetailsUpdateDto;
}

export interface UpdateReceiptRequest {
    receiptId: number;
    iReceiptPatchDto: IReceiptPatchDto;
}

/**
 * DocumentServiceServiceApi - interface
 * 
 * @export
 * @interface DocumentServiceServiceApiInterface
 */
export interface DocumentServiceServiceApiInterface {
    /**
     * Copy files from source documents into target document
     * @param {number} documentId 
     * @param {ICopyFilesRequestDto} iCopyFilesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    copyFilesFromDocumentsRaw(requestParameters: CopyFilesFromDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentFilesUrlDto>>;

    /**
     * Copy files from source documents into target document
     */
    copyFilesFromDocuments(requestParameters: CopyFilesFromDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentFilesUrlDto>;

    /**
     * create new document by one time link
     * @param {IDocumentOneTimeLinkDto} iDocumentOneTimeLinkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    createDocumentByOneTimeLinkRaw(requestParameters: CreateDocumentByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentIdDto>>;

    /**
     * create new document by one time link
     */
    createDocumentByOneTimeLink(requestParameters: CreateDocumentByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentIdDto>;

    /**
     * create new document by qr-code
     * @param {IDocumentQrCodeDto} iDocumentQrCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    createDocumentByQrCodeRaw(requestParameters: CreateDocumentByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentIdDto>>;

    /**
     * create new document by qr-code
     */
    createDocumentByQrCode(requestParameters: CreateDocumentByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentIdDto>;

    /**
     * Create draft receipt
     * @param {IReceiptDto} iReceiptDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    createDraftReceiptRaw(requestParameters: CreateDraftReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReceiptDto>>;

    /**
     * Create draft receipt
     */
    createDraftReceipt(requestParameters: CreateDraftReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReceiptDto>;

    /**
     * Create new receipt
     * @param {IReceiptDto} iReceiptDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    createReceiptRaw(requestParameters: CreateReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReceiptDto>>;

    /**
     * Create new receipt
     */
    createReceipt(requestParameters: CreateReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReceiptDto>;

    /**
     * Deactivate one time link by hash-id
     * @param {string} hashId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    deactivateOneTimeLinkRaw(requestParameters: DeactivateOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deactivate one time link by hash-id
     */
    deactivateOneTimeLink(requestParameters: DeactivateOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * delete document by id
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    deleteDocumentRaw(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * delete document by id
     */
    deleteDocument(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * delete document file
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    deleteDocumentFileRaw(requestParameters: DeleteDocumentFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * delete document file
     */
    deleteDocumentFile(requestParameters: DeleteDocumentFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * imports document file by one time link
     * @param {number} documentId 
     * @param {string} hashId 
     * @param {number} employeeId 
     * @param {Blob} file document file to be uploaded
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    documentFileImportByOneTimeLinkRaw(requestParameters: DocumentFileImportByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>>;

    /**
     * imports document file by one time link
     */
    documentFileImportByOneTimeLink(requestParameters: DocumentFileImportByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto>;

    /**
     * imports document file by qr-code
     * @param {number} documentId 
     * @param {string} qrId 
     * @param {number} employeeId 
     * @param {Blob} file document file to be uploaded
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    documentFileImportByQrCodeRaw(requestParameters: DocumentFileImportByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>>;

    /**
     * imports document file by qr-code
     */
    documentFileImportByQrCode(requestParameters: DocumentFileImportByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto>;

    /**
     * Does file exist by id
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    fileExistsRaw(requestParameters: FileExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>>;

    /**
     * Does file exist by id
     */
    fileExists(requestParameters: FileExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean>;

    /**
     * Find one time link by hash-id
     * @param {string} hashId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    findOneTimeLinkRaw(requestParameters: FindOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOneTimeLinkResponseDto>>;

    /**
     * Find one time link by hash-id
     */
    findOneTimeLink(requestParameters: FindOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOneTimeLinkResponseDto>;

    /**
     * generate qr code
     * @param {IDocumentIdDto} [iDocumentIdDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    generateQrCodeRaw(requestParameters: GenerateQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IQrCodeDto>>;

    /**
     * generate qr code
     */
    generateQrCode(requestParameters: GenerateQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IQrCodeDto>;

    /**
     * Get claim repayment lockbox by id
     * @param {number} lockboxId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    getClaimRepaymentLockboxByIdRaw(requestParameters: GetClaimRepaymentLockboxByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxClaimRepaymentDto>>;

    /**
     * Get claim repayment lockbox by id
     */
    getClaimRepaymentLockboxById(requestParameters: GetClaimRepaymentLockboxByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxClaimRepaymentDto>;

    /**
     * 
     * @summary Returns stream of document files url by qr-code
     * @param {string} qrId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    getDocumentFilesUrlStreamRaw(requestParameters: GetDocumentFilesUrlStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IDocumentFilesUrlDto>>>;

    /**
     * Returns stream of document files url by qr-code
     */
    getDocumentFilesUrlStream(requestParameters: GetDocumentFilesUrlStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IDocumentFilesUrlDto>>;

    /**
     * Returns document id dto by file id
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    getDocumentIdByFileIdRaw(requestParameters: GetDocumentIdByFileIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentFilesUrlDto>>;

    /**
     * Returns document id dto by file id
     */
    getDocumentIdByFileId(requestParameters: GetDocumentIdByFileIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentFilesUrlDto>;

    /**
     * Returns files url dto by document id
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    getDocumentUrlDtoByDocumentIdRaw(requestParameters: GetDocumentUrlDtoByDocumentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentFilesUrlDto>>;

    /**
     * Returns files url dto by document id
     */
    getDocumentUrlDtoByDocumentId(requestParameters: GetDocumentUrlDtoByDocumentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentFilesUrlDto>;

    /**
     * Returns files url dto for multiple document ids
     * @param {Set<number>} documentIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    getDocumentsFilesUrlDtoByDocumentIdsRaw(requestParameters: GetDocumentsFilesUrlDtoByDocumentIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IDocumentFilesUrlDto>>>;

    /**
     * Returns files url dto for multiple document ids
     */
    getDocumentsFilesUrlDtoByDocumentIds(requestParameters: GetDocumentsFilesUrlDtoByDocumentIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IDocumentFilesUrlDto>>;

    /**
     * Retrieve receipt document files by receipt id
     * @param {number} receiptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    getReceiptDocumentFilesRaw(requestParameters: GetReceiptDocumentFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IReceiptDocumentFileDto>>>;

    /**
     * Retrieve receipt document files by receipt id
     */
    getReceiptDocumentFiles(requestParameters: GetReceiptDocumentFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IReceiptDocumentFileDto>>;

    /**
     * imports document file
     * @param {number} documentId 
     * @param {Blob} file document file to be uploaded
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    handleDocumentFileImport1Raw(requestParameters: HandleDocumentFileImport1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>>;

    /**
     * imports document file
     */
    handleDocumentFileImport1(requestParameters: HandleDocumentFileImport1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto>;

    /**
     * Validate document file import completion
     * @param {number} documentId 
     * @param {IDocumentFileUploadCompletionDto} iDocumentFileUploadCompletionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    handleDocumentFileImportCompletionRaw(requestParameters: HandleDocumentFileImportCompletionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>>;

    /**
     * Validate document file import completion
     */
    handleDocumentFileImportCompletion(requestParameters: HandleDocumentFileImportCompletionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto>;

    /**
     * Validate document file import completion by qr code
     * @param {number} documentId 
     * @param {IDocumentFileUploadByQrCodeDto} iDocumentFileUploadByQrCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    handleDocumentFileImportCompletion1Raw(requestParameters: HandleDocumentFileImportCompletion1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>>;

    /**
     * Validate document file import completion by qr code
     */
    handleDocumentFileImportCompletion1(requestParameters: HandleDocumentFileImportCompletion1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto>;

    /**
     * Validate document file import completion by link
     * @param {number} documentId 
     * @param {IDocumentFileUploadByLinkDto} iDocumentFileUploadByLinkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    handleDocumentFileImportCompletion2Raw(requestParameters: HandleDocumentFileImportCompletion2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>>;

    /**
     * Validate document file import completion by link
     */
    handleDocumentFileImportCompletion2(requestParameters: HandleDocumentFileImportCompletion2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto>;

    /**
     * Open AI OCR Docs Needed file matching with provided details
     * @param {number} fileId 
     * @param {IOcrDto} iOcrDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    matchFileWithOpenAiRaw(requestParameters: MatchFileWithOpenAiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrReceiptResponseDto>>;

    /**
     * Open AI OCR Docs Needed file matching with provided details
     */
    matchFileWithOpenAi(requestParameters: MatchFileWithOpenAiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrReceiptResponseDto>;

    /**
     * Open AI OCR parse file by id
     * @param {number} fileId 
     * @param {number} [employeeId] 
     * @param {IOcrDto} [iOcrDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    parseFileWithOpenAiRaw(requestParameters: ParseFileWithOpenAiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrReceiptResponseDto>>;

    /**
     * Open AI OCR parse file by id
     */
    parseFileWithOpenAi(requestParameters: ParseFileWithOpenAiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrReceiptResponseDto>;

    /**
     * Generate presigned S3 upload url for document file by one time link
     * @param {number} documentId 
     * @param {IOneTimeLinkPresignUrlRequestDto} iOneTimeLinkPresignUrlRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    presignUploadUrlByOneTimeLinkRaw(requestParameters: PresignUploadUrlByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPresignUrlResponse>>;

    /**
     * Generate presigned S3 upload url for document file by one time link
     */
    presignUploadUrlByOneTimeLink(requestParameters: PresignUploadUrlByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPresignUrlResponse>;

    /**
     * Generate presigned S3 upload url for document file by qr-code
     * @param {number} documentId 
     * @param {IQrCodePresignUrlRequestDto} iQrCodePresignUrlRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    presignUploadUrlByQrCodeRaw(requestParameters: PresignUploadUrlByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPresignUrlResponse>>;

    /**
     * Generate presigned S3 upload url for document file by qr-code
     */
    presignUploadUrlByQrCode(requestParameters: PresignUploadUrlByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPresignUrlResponse>;

    /**
     * Create presigned URL to upload a file
     * @param {number} documentId 
     * @param {IPresignUrlRequestDto} iPresignUrlRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    presignUrlRaw(requestParameters: PresignUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPresignUrlResponse>>;

    /**
     * Create presigned URL to upload a file
     */
    presignUrl(requestParameters: PresignUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPresignUrlResponse>;

    /**
     * Submit returned check processing decisions for the participant
     * @param {IReturnedCheckDecisionsDto} iReturnedCheckDecisionsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    processReturnedCheckDecisionsRaw(requestParameters: ProcessReturnedCheckDecisionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProcessedReturnedChecksDto>>;

    /**
     * Submit returned check processing decisions for the participant
     */
    processReturnedCheckDecisions(requestParameters: ProcessReturnedCheckDecisionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProcessedReturnedChecksDto>;

    /**
     * Retrieve lockboxes
     * @param {Array<'UNKNOWN' | 'INBOUND_TOA' | 'OUTBOUND_TOA' | 'RETURNED_CHECK' | 'CLAIM_REPAYMENT' | 'BENEFICIARY' | 'HSA_FORM' | 'MISTAKEN_DISTRIBUTION' | 'HSA_ROLLOVER_FORM' | 'HSA_CONTRIBUTION_FORM' | 'HSA_TRANSFER_DIVORCE' | 'HSA_ACCOUNT_CLOSURE' | 'COMBINE_HSA' | 'DEATH_DISTRIBUTION' | 'POWER_OF_ATTORNEY' | 'RETURNED_MAIL' | 'EXCESS_CONTRIBUTION'>} [types] 
     * @param {Array<'NEW' | 'PENDING' | 'DECLINED' | 'APPROVED' | 'PROCESSING' | 'COMPLETED' | 'INVESTMENTS_LIQUIDATED' | 'CANCELED' | 'DIVIDED' | 'PARTIALLY_APPROVED' | 'PROCESSED_MANUALLY'>} [statuses] 
     * @param {string} [searchValue] 
     * @param {Array<'CHECK' | 'WIRE'>} [paymentMethods] 
     * @param {Array<'SENT' | 'NOT_SENT'>} [wireStatuses] 
     * @param {Set<number>} [ids] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    retrieveLockboxesRaw(requestParameters: RetrieveLockboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxDto>>;

    /**
     * Retrieve lockboxes
     */
    retrieveLockboxes(requestParameters: RetrieveLockboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxDto>;

    /**
     * Returns ocr details dto by document id
     * @param {number} documentId 
     * @param {IOcrDetailsRequestDto} [iOcrDetailsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    retrieveOcrDetailsRaw(requestParameters: RetrieveOcrDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrDetailsDto>>;

    /**
     * Returns ocr details dto by document id
     */
    retrieveOcrDetails(requestParameters: RetrieveOcrDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrDetailsDto>;

    /**
     * 
     * @param {number} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    retrieveOcrDetails1Raw(requestParameters: RetrieveOcrDetails1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrDetailsDto>>;

    /**
     */
    retrieveOcrDetails1(requestParameters: RetrieveOcrDetails1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrDetailsDto>;

    /**
     * Retrieve returned mail types pending resend for the participant
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    retrieveReturnedItemsRaw(requestParameters: RetrieveReturnedItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReturnedItemsDto>>;

    /**
     * Retrieve returned mail types pending resend for the participant
     */
    retrieveReturnedItems(requestParameters: RetrieveReturnedItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReturnedItemsDto>;

    /**
     * Retrieve vendors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    retrieveVendorsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IVendorDto>>;

    /**
     * Retrieve vendors
     */
    retrieveVendors(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IVendorDto>;

    /**
     * get document by id and for employeeId from token
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    searchDocumentForEmployeeWithIdRaw(requestParameters: SearchDocumentForEmployeeWithIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * get document by id and for employeeId from token
     */
    searchDocumentForEmployeeWithId(requestParameters: SearchDocumentForEmployeeWithIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Split lockbox
     * @param {number} lockboxId 
     * @param {IMultipleRecordsDto} iMultipleRecordsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    splitLockboxRaw(requestParameters: SplitLockboxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxDto>>;

    /**
     * Split lockbox
     */
    splitLockbox(requestParameters: SplitLockboxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxDto>;

    /**
     * Update check details
     * @param {number} lockboxId 
     * @param {ICheckDetailsUpdateDto} iCheckDetailsUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    updateCheckDetailsRaw(requestParameters: UpdateCheckDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICheckDetailsDto>>;

    /**
     * Update check details
     */
    updateCheckDetails(requestParameters: UpdateCheckDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICheckDetailsDto>;

    /**
     * Update receipt
     * @param {number} receiptId 
     * @param {IReceiptPatchDto} iReceiptPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentServiceServiceApiInterface
     */
    updateReceiptRaw(requestParameters: UpdateReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update receipt
     */
    updateReceipt(requestParameters: UpdateReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class DocumentServiceServiceApi extends runtime.BaseAPI implements DocumentServiceServiceApiInterface {

    /**
     * Copy files from source documents into target document
     */
    async copyFilesFromDocumentsRaw(requestParameters: CopyFilesFromDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentFilesUrlDto>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling copyFilesFromDocuments().'
            );
        }

        if (requestParameters['iCopyFilesRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iCopyFilesRequestDto',
                'Required parameter "iCopyFilesRequestDto" was null or undefined when calling copyFilesFromDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}/files`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICopyFilesRequestDtoToJSON(requestParameters['iCopyFilesRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDocumentFilesUrlDtoFromJSON(jsonValue));
    }

    /**
     * Copy files from source documents into target document
     */
    async copyFilesFromDocuments(requestParameters: CopyFilesFromDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentFilesUrlDto> {
        const response = await this.copyFilesFromDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create new document by one time link
     */
    async createDocumentByOneTimeLinkRaw(requestParameters: CreateDocumentByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentIdDto>> {
        if (requestParameters['iDocumentOneTimeLinkDto'] == null) {
            throw new runtime.RequiredError(
                'iDocumentOneTimeLinkDto',
                'Required parameter "iDocumentOneTimeLinkDto" was null or undefined when calling createDocumentByOneTimeLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/receipts/by-link`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDocumentOneTimeLinkDtoToJSON(requestParameters['iDocumentOneTimeLinkDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDocumentIdDtoFromJSON(jsonValue));
    }

    /**
     * create new document by one time link
     */
    async createDocumentByOneTimeLink(requestParameters: CreateDocumentByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentIdDto> {
        const response = await this.createDocumentByOneTimeLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create new document by qr-code
     */
    async createDocumentByQrCodeRaw(requestParameters: CreateDocumentByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentIdDto>> {
        if (requestParameters['iDocumentQrCodeDto'] == null) {
            throw new runtime.RequiredError(
                'iDocumentQrCodeDto',
                'Required parameter "iDocumentQrCodeDto" was null or undefined when calling createDocumentByQrCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/receipts/by-qr-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDocumentQrCodeDtoToJSON(requestParameters['iDocumentQrCodeDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDocumentIdDtoFromJSON(jsonValue));
    }

    /**
     * create new document by qr-code
     */
    async createDocumentByQrCode(requestParameters: CreateDocumentByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentIdDto> {
        const response = await this.createDocumentByQrCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create draft receipt
     */
    async createDraftReceiptRaw(requestParameters: CreateDraftReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReceiptDto>> {
        if (requestParameters['iReceiptDto'] == null) {
            throw new runtime.RequiredError(
                'iReceiptDto',
                'Required parameter "iReceiptDto" was null or undefined when calling createDraftReceipt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/receipts/draft`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IReceiptDtoToJSON(requestParameters['iReceiptDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReceiptDtoFromJSON(jsonValue));
    }

    /**
     * Create draft receipt
     */
    async createDraftReceipt(requestParameters: CreateDraftReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReceiptDto> {
        const response = await this.createDraftReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new receipt
     */
    async createReceiptRaw(requestParameters: CreateReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReceiptDto>> {
        if (requestParameters['iReceiptDto'] == null) {
            throw new runtime.RequiredError(
                'iReceiptDto',
                'Required parameter "iReceiptDto" was null or undefined when calling createReceipt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/receipts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IReceiptDtoToJSON(requestParameters['iReceiptDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReceiptDtoFromJSON(jsonValue));
    }

    /**
     * Create new receipt
     */
    async createReceipt(requestParameters: CreateReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReceiptDto> {
        const response = await this.createReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivate one time link by hash-id
     */
    async deactivateOneTimeLinkRaw(requestParameters: DeactivateOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['hashId'] == null) {
            throw new runtime.RequiredError(
                'hashId',
                'Required parameter "hashId" was null or undefined when calling deactivateOneTimeLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/documents/one-time-links/{hash-id}/deactivation`;
        urlPath = urlPath.replace(`{${"hash-id"}}`, encodeURIComponent(String(requestParameters['hashId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deactivate one time link by hash-id
     */
    async deactivateOneTimeLink(requestParameters: DeactivateOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deactivateOneTimeLinkRaw(requestParameters, initOverrides);
    }

    /**
     * delete document by id
     */
    async deleteDocumentRaw(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete document by id
     */
    async deleteDocument(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentRaw(requestParameters, initOverrides);
    }

    /**
     * delete document file
     */
    async deleteDocumentFileRaw(requestParameters: DeleteDocumentFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling deleteDocumentFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/files/{file-id}`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete document file
     */
    async deleteDocumentFile(requestParameters: DeleteDocumentFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentFileRaw(requestParameters, initOverrides);
    }

    /**
     * imports document file by one time link
     */
    async documentFileImportByOneTimeLinkRaw(requestParameters: DocumentFileImportByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling documentFileImportByOneTimeLink().'
            );
        }

        if (requestParameters['hashId'] == null) {
            throw new runtime.RequiredError(
                'hashId',
                'Required parameter "hashId" was null or undefined when calling documentFileImportByOneTimeLink().'
            );
        }

        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling documentFileImportByOneTimeLink().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling documentFileImportByOneTimeLink().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['hashId'] != null) {
            queryParameters['hash_id'] = requestParameters['hashId'];
        }

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/documents/{document-id}/files/by-link/import`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileUrlsResponseDtoFromJSON(jsonValue));
    }

    /**
     * imports document file by one time link
     */
    async documentFileImportByOneTimeLink(requestParameters: DocumentFileImportByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto> {
        const response = await this.documentFileImportByOneTimeLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * imports document file by qr-code
     */
    async documentFileImportByQrCodeRaw(requestParameters: DocumentFileImportByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling documentFileImportByQrCode().'
            );
        }

        if (requestParameters['qrId'] == null) {
            throw new runtime.RequiredError(
                'qrId',
                'Required parameter "qrId" was null or undefined when calling documentFileImportByQrCode().'
            );
        }

        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling documentFileImportByQrCode().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling documentFileImportByQrCode().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['qrId'] != null) {
            queryParameters['qr_id'] = requestParameters['qrId'];
        }

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/documents/{document-id}/files/by-qr-codes/import`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileUrlsResponseDtoFromJSON(jsonValue));
    }

    /**
     * imports document file by qr-code
     */
    async documentFileImportByQrCode(requestParameters: DocumentFileImportByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto> {
        const response = await this.documentFileImportByQrCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Does file exist by id
     */
    async fileExistsRaw(requestParameters: FileExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling fileExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/files/{file-id}/exists`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Does file exist by id
     */
    async fileExists(requestParameters: FileExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.fileExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find one time link by hash-id
     */
    async findOneTimeLinkRaw(requestParameters: FindOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOneTimeLinkResponseDto>> {
        if (requestParameters['hashId'] == null) {
            throw new runtime.RequiredError(
                'hashId',
                'Required parameter "hashId" was null or undefined when calling findOneTimeLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/documents/one-time-links/{hash-id}`;
        urlPath = urlPath.replace(`{${"hash-id"}}`, encodeURIComponent(String(requestParameters['hashId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOneTimeLinkResponseDtoFromJSON(jsonValue));
    }

    /**
     * Find one time link by hash-id
     */
    async findOneTimeLink(requestParameters: FindOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOneTimeLinkResponseDto> {
        const response = await this.findOneTimeLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * generate qr code
     */
    async generateQrCodeRaw(requestParameters: GenerateQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IQrCodeDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/receipts/qr-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDocumentIdDtoToJSON(requestParameters['iDocumentIdDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IQrCodeDtoFromJSON(jsonValue));
    }

    /**
     * generate qr code
     */
    async generateQrCode(requestParameters: GenerateQrCodeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IQrCodeDto> {
        const response = await this.generateQrCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get claim repayment lockbox by id
     */
    async getClaimRepaymentLockboxByIdRaw(requestParameters: GetClaimRepaymentLockboxByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxClaimRepaymentDto>> {
        if (requestParameters['lockboxId'] == null) {
            throw new runtime.RequiredError(
                'lockboxId',
                'Required parameter "lockboxId" was null or undefined when calling getClaimRepaymentLockboxById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lockboxes/claim-repayment/{lockbox-id}`;
        urlPath = urlPath.replace(`{${"lockbox-id"}}`, encodeURIComponent(String(requestParameters['lockboxId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ILockboxClaimRepaymentDtoFromJSON(jsonValue));
    }

    /**
     * Get claim repayment lockbox by id
     */
    async getClaimRepaymentLockboxById(requestParameters: GetClaimRepaymentLockboxByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxClaimRepaymentDto> {
        const response = await this.getClaimRepaymentLockboxByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns stream of document files url by qr-code
     */
    async getDocumentFilesUrlStreamRaw(requestParameters: GetDocumentFilesUrlStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IDocumentFilesUrlDto>>> {
        if (requestParameters['qrId'] == null) {
            throw new runtime.RequiredError(
                'qrId',
                'Required parameter "qrId" was null or undefined when calling getDocumentFilesUrlStream().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['qrId'] != null) {
            queryParameters['qr_id'] = requestParameters['qrId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/receipts/file/by-qr-codes/stream`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IDocumentFilesUrlDtoFromJSON));
    }

    /**
     * Returns stream of document files url by qr-code
     */
    async getDocumentFilesUrlStream(requestParameters: GetDocumentFilesUrlStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IDocumentFilesUrlDto>> {
        const response = await this.getDocumentFilesUrlStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns document id dto by file id
     */
    async getDocumentIdByFileIdRaw(requestParameters: GetDocumentIdByFileIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentFilesUrlDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling getDocumentIdByFileId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fileId'] != null) {
            queryParameters['file_id'] = requestParameters['fileId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDocumentFilesUrlDtoFromJSON(jsonValue));
    }

    /**
     * Returns document id dto by file id
     */
    async getDocumentIdByFileId(requestParameters: GetDocumentIdByFileIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentFilesUrlDto> {
        const response = await this.getDocumentIdByFileIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns files url dto by document id
     */
    async getDocumentUrlDtoByDocumentIdRaw(requestParameters: GetDocumentUrlDtoByDocumentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDocumentFilesUrlDto>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getDocumentUrlDtoByDocumentId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}/files`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDocumentFilesUrlDtoFromJSON(jsonValue));
    }

    /**
     * Returns files url dto by document id
     */
    async getDocumentUrlDtoByDocumentId(requestParameters: GetDocumentUrlDtoByDocumentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDocumentFilesUrlDto> {
        const response = await this.getDocumentUrlDtoByDocumentIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns files url dto for multiple document ids
     */
    async getDocumentsFilesUrlDtoByDocumentIdsRaw(requestParameters: GetDocumentsFilesUrlDtoByDocumentIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IDocumentFilesUrlDto>>> {
        if (requestParameters['documentIds'] == null) {
            throw new runtime.RequiredError(
                'documentIds',
                'Required parameter "documentIds" was null or undefined when calling getDocumentsFilesUrlDtoByDocumentIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['documentIds'] != null) {
            queryParameters['document-ids'] = requestParameters['documentIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/files`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IDocumentFilesUrlDtoFromJSON));
    }

    /**
     * Returns files url dto for multiple document ids
     */
    async getDocumentsFilesUrlDtoByDocumentIds(requestParameters: GetDocumentsFilesUrlDtoByDocumentIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IDocumentFilesUrlDto>> {
        const response = await this.getDocumentsFilesUrlDtoByDocumentIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve receipt document files by receipt id
     */
    async getReceiptDocumentFilesRaw(requestParameters: GetReceiptDocumentFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IReceiptDocumentFileDto>>> {
        if (requestParameters['receiptId'] == null) {
            throw new runtime.RequiredError(
                'receiptId',
                'Required parameter "receiptId" was null or undefined when calling getReceiptDocumentFiles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/receipts/{receipt-id}/files`;
        urlPath = urlPath.replace(`{${"receipt-id"}}`, encodeURIComponent(String(requestParameters['receiptId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IReceiptDocumentFileDtoFromJSON));
    }

    /**
     * Retrieve receipt document files by receipt id
     */
    async getReceiptDocumentFiles(requestParameters: GetReceiptDocumentFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IReceiptDocumentFileDto>> {
        const response = await this.getReceiptDocumentFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * imports document file
     */
    async handleDocumentFileImport1Raw(requestParameters: HandleDocumentFileImport1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling handleDocumentFileImport1().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling handleDocumentFileImport1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/documents/{document-id}/import`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileUrlsResponseDtoFromJSON(jsonValue));
    }

    /**
     * imports document file
     */
    async handleDocumentFileImport1(requestParameters: HandleDocumentFileImport1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto> {
        const response = await this.handleDocumentFileImport1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate document file import completion
     */
    async handleDocumentFileImportCompletionRaw(requestParameters: HandleDocumentFileImportCompletionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling handleDocumentFileImportCompletion().'
            );
        }

        if (requestParameters['iDocumentFileUploadCompletionDto'] == null) {
            throw new runtime.RequiredError(
                'iDocumentFileUploadCompletionDto',
                'Required parameter "iDocumentFileUploadCompletionDto" was null or undefined when calling handleDocumentFileImportCompletion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}/files/link/complete`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDocumentFileUploadCompletionDtoToJSON(requestParameters['iDocumentFileUploadCompletionDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileUrlsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Validate document file import completion
     */
    async handleDocumentFileImportCompletion(requestParameters: HandleDocumentFileImportCompletionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto> {
        const response = await this.handleDocumentFileImportCompletionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate document file import completion by qr code
     */
    async handleDocumentFileImportCompletion1Raw(requestParameters: HandleDocumentFileImportCompletion1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling handleDocumentFileImportCompletion1().'
            );
        }

        if (requestParameters['iDocumentFileUploadByQrCodeDto'] == null) {
            throw new runtime.RequiredError(
                'iDocumentFileUploadByQrCodeDto',
                'Required parameter "iDocumentFileUploadByQrCodeDto" was null or undefined when calling handleDocumentFileImportCompletion1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}/files/by-qr-codes/link/complete`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDocumentFileUploadByQrCodeDtoToJSON(requestParameters['iDocumentFileUploadByQrCodeDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileUrlsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Validate document file import completion by qr code
     */
    async handleDocumentFileImportCompletion1(requestParameters: HandleDocumentFileImportCompletion1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto> {
        const response = await this.handleDocumentFileImportCompletion1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate document file import completion by link
     */
    async handleDocumentFileImportCompletion2Raw(requestParameters: HandleDocumentFileImportCompletion2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlsResponseDto>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling handleDocumentFileImportCompletion2().'
            );
        }

        if (requestParameters['iDocumentFileUploadByLinkDto'] == null) {
            throw new runtime.RequiredError(
                'iDocumentFileUploadByLinkDto',
                'Required parameter "iDocumentFileUploadByLinkDto" was null or undefined when calling handleDocumentFileImportCompletion2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}/files/by-link/link/complete`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDocumentFileUploadByLinkDtoToJSON(requestParameters['iDocumentFileUploadByLinkDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileUrlsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Validate document file import completion by link
     */
    async handleDocumentFileImportCompletion2(requestParameters: HandleDocumentFileImportCompletion2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlsResponseDto> {
        const response = await this.handleDocumentFileImportCompletion2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Open AI OCR Docs Needed file matching with provided details
     */
    async matchFileWithOpenAiRaw(requestParameters: MatchFileWithOpenAiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrReceiptResponseDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling matchFileWithOpenAi().'
            );
        }

        if (requestParameters['iOcrDto'] == null) {
            throw new runtime.RequiredError(
                'iOcrDto',
                'Required parameter "iOcrDto" was null or undefined when calling matchFileWithOpenAi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/files/{file-id}/openai/ocr/matching`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IOcrDtoToJSON(requestParameters['iOcrDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOcrReceiptResponseDtoFromJSON(jsonValue));
    }

    /**
     * Open AI OCR Docs Needed file matching with provided details
     */
    async matchFileWithOpenAi(requestParameters: MatchFileWithOpenAiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrReceiptResponseDto> {
        const response = await this.matchFileWithOpenAiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Open AI OCR parse file by id
     */
    async parseFileWithOpenAiRaw(requestParameters: ParseFileWithOpenAiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrReceiptResponseDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling parseFileWithOpenAi().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/files/{file-id}/openai/ocr-reader`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IOcrDtoToJSON(requestParameters['iOcrDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOcrReceiptResponseDtoFromJSON(jsonValue));
    }

    /**
     * Open AI OCR parse file by id
     */
    async parseFileWithOpenAi(requestParameters: ParseFileWithOpenAiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrReceiptResponseDto> {
        const response = await this.parseFileWithOpenAiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate presigned S3 upload url for document file by one time link
     */
    async presignUploadUrlByOneTimeLinkRaw(requestParameters: PresignUploadUrlByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPresignUrlResponse>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling presignUploadUrlByOneTimeLink().'
            );
        }

        if (requestParameters['iOneTimeLinkPresignUrlRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iOneTimeLinkPresignUrlRequestDto',
                'Required parameter "iOneTimeLinkPresignUrlRequestDto" was null or undefined when calling presignUploadUrlByOneTimeLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}/files/by-link/link`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IOneTimeLinkPresignUrlRequestDtoToJSON(requestParameters['iOneTimeLinkPresignUrlRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPresignUrlResponseFromJSON(jsonValue));
    }

    /**
     * Generate presigned S3 upload url for document file by one time link
     */
    async presignUploadUrlByOneTimeLink(requestParameters: PresignUploadUrlByOneTimeLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPresignUrlResponse> {
        const response = await this.presignUploadUrlByOneTimeLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate presigned S3 upload url for document file by qr-code
     */
    async presignUploadUrlByQrCodeRaw(requestParameters: PresignUploadUrlByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPresignUrlResponse>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling presignUploadUrlByQrCode().'
            );
        }

        if (requestParameters['iQrCodePresignUrlRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iQrCodePresignUrlRequestDto',
                'Required parameter "iQrCodePresignUrlRequestDto" was null or undefined when calling presignUploadUrlByQrCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}/files/by-qr-codes/link`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IQrCodePresignUrlRequestDtoToJSON(requestParameters['iQrCodePresignUrlRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPresignUrlResponseFromJSON(jsonValue));
    }

    /**
     * Generate presigned S3 upload url for document file by qr-code
     */
    async presignUploadUrlByQrCode(requestParameters: PresignUploadUrlByQrCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPresignUrlResponse> {
        const response = await this.presignUploadUrlByQrCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create presigned URL to upload a file
     */
    async presignUrlRaw(requestParameters: PresignUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPresignUrlResponse>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling presignUrl().'
            );
        }

        if (requestParameters['iPresignUrlRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iPresignUrlRequestDto',
                'Required parameter "iPresignUrlRequestDto" was null or undefined when calling presignUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}/files/link`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPresignUrlRequestDtoToJSON(requestParameters['iPresignUrlRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPresignUrlResponseFromJSON(jsonValue));
    }

    /**
     * Create presigned URL to upload a file
     */
    async presignUrl(requestParameters: PresignUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPresignUrlResponse> {
        const response = await this.presignUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit returned check processing decisions for the participant
     */
    async processReturnedCheckDecisionsRaw(requestParameters: ProcessReturnedCheckDecisionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProcessedReturnedChecksDto>> {
        if (requestParameters['iReturnedCheckDecisionsDto'] == null) {
            throw new runtime.RequiredError(
                'iReturnedCheckDecisionsDto',
                'Required parameter "iReturnedCheckDecisionsDto" was null or undefined when calling processReturnedCheckDecisions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lockboxes/returned-checks/processing-decisions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IReturnedCheckDecisionsDtoToJSON(requestParameters['iReturnedCheckDecisionsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IProcessedReturnedChecksDtoFromJSON(jsonValue));
    }

    /**
     * Submit returned check processing decisions for the participant
     */
    async processReturnedCheckDecisions(requestParameters: ProcessReturnedCheckDecisionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProcessedReturnedChecksDto> {
        const response = await this.processReturnedCheckDecisionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve lockboxes
     */
    async retrieveLockboxesRaw(requestParameters: RetrieveLockboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxDto>> {
        const queryParameters: any = {};

        if (requestParameters['types'] != null) {
            queryParameters['types'] = requestParameters['types'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['paymentMethods'] != null) {
            queryParameters['payment_methods'] = requestParameters['paymentMethods'];
        }

        if (requestParameters['wireStatuses'] != null) {
            queryParameters['wire_statuses'] = requestParameters['wireStatuses'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lockboxes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ILockboxDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve lockboxes
     */
    async retrieveLockboxes(requestParameters: RetrieveLockboxesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxDto> {
        const response = await this.retrieveLockboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns ocr details dto by document id
     */
    async retrieveOcrDetailsRaw(requestParameters: RetrieveOcrDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrDetailsDto>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling retrieveOcrDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}/ocrs`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IOcrDetailsRequestDtoToJSON(requestParameters['iOcrDetailsRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOcrDetailsDtoFromJSON(jsonValue));
    }

    /**
     * Returns ocr details dto by document id
     */
    async retrieveOcrDetails(requestParameters: RetrieveOcrDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrDetailsDto> {
        const response = await this.retrieveOcrDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async retrieveOcrDetails1Raw(requestParameters: RetrieveOcrDetails1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOcrDetailsDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling retrieveOcrDetails1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['claimId'] != null) {
            queryParameters['claim_id'] = requestParameters['claimId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/receipts/ocr`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOcrDetailsDtoFromJSON(jsonValue));
    }

    /**
     */
    async retrieveOcrDetails1(requestParameters: RetrieveOcrDetails1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOcrDetailsDto> {
        const response = await this.retrieveOcrDetails1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve returned mail types pending resend for the participant
     */
    async retrieveReturnedItemsRaw(requestParameters: RetrieveReturnedItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReturnedItemsDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lockboxes/returned-items`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReturnedItemsDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve returned mail types pending resend for the participant
     */
    async retrieveReturnedItems(requestParameters: RetrieveReturnedItemsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReturnedItemsDto> {
        const response = await this.retrieveReturnedItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve vendors
     */
    async retrieveVendorsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IVendorDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vendors`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IVendorDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve vendors
     */
    async retrieveVendors(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IVendorDto> {
        const response = await this.retrieveVendorsRaw(initOverrides);
        return await response.value();
    }

    /**
     * get document by id and for employeeId from token
     */
    async searchDocumentForEmployeeWithIdRaw(requestParameters: SearchDocumentForEmployeeWithIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling searchDocumentForEmployeeWithId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/{document-id}`;
        urlPath = urlPath.replace(`{${"document-id"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * get document by id and for employeeId from token
     */
    async searchDocumentForEmployeeWithId(requestParameters: SearchDocumentForEmployeeWithIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.searchDocumentForEmployeeWithIdRaw(requestParameters, initOverrides);
    }

    /**
     * Split lockbox
     */
    async splitLockboxRaw(requestParameters: SplitLockboxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILockboxDto>> {
        if (requestParameters['lockboxId'] == null) {
            throw new runtime.RequiredError(
                'lockboxId',
                'Required parameter "lockboxId" was null or undefined when calling splitLockbox().'
            );
        }

        if (requestParameters['iMultipleRecordsDto'] == null) {
            throw new runtime.RequiredError(
                'iMultipleRecordsDto',
                'Required parameter "iMultipleRecordsDto" was null or undefined when calling splitLockbox().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lockboxes/{lockbox-id}/splitting`;
        urlPath = urlPath.replace(`{${"lockbox-id"}}`, encodeURIComponent(String(requestParameters['lockboxId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IMultipleRecordsDtoToJSON(requestParameters['iMultipleRecordsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ILockboxDtoFromJSON(jsonValue));
    }

    /**
     * Split lockbox
     */
    async splitLockbox(requestParameters: SplitLockboxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILockboxDto> {
        const response = await this.splitLockboxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update check details
     */
    async updateCheckDetailsRaw(requestParameters: UpdateCheckDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICheckDetailsDto>> {
        if (requestParameters['lockboxId'] == null) {
            throw new runtime.RequiredError(
                'lockboxId',
                'Required parameter "lockboxId" was null or undefined when calling updateCheckDetails().'
            );
        }

        if (requestParameters['iCheckDetailsUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iCheckDetailsUpdateDto',
                'Required parameter "iCheckDetailsUpdateDto" was null or undefined when calling updateCheckDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lockboxes/{lockbox-id}/check-details`;
        urlPath = urlPath.replace(`{${"lockbox-id"}}`, encodeURIComponent(String(requestParameters['lockboxId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ICheckDetailsUpdateDtoToJSON(requestParameters['iCheckDetailsUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICheckDetailsDtoFromJSON(jsonValue));
    }

    /**
     * Update check details
     */
    async updateCheckDetails(requestParameters: UpdateCheckDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICheckDetailsDto> {
        const response = await this.updateCheckDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update receipt
     */
    async updateReceiptRaw(requestParameters: UpdateReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['receiptId'] == null) {
            throw new runtime.RequiredError(
                'receiptId',
                'Required parameter "receiptId" was null or undefined when calling updateReceipt().'
            );
        }

        if (requestParameters['iReceiptPatchDto'] == null) {
            throw new runtime.RequiredError(
                'iReceiptPatchDto',
                'Required parameter "iReceiptPatchDto" was null or undefined when calling updateReceipt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/receipts/{receipt-id}`;
        urlPath = urlPath.replace(`{${"receipt-id"}}`, encodeURIComponent(String(requestParameters['receiptId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IReceiptPatchDtoToJSON(requestParameters['iReceiptPatchDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update receipt
     */
    async updateReceipt(requestParameters: UpdateReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReceiptRaw(requestParameters, initOverrides);
    }

}

/**
  * @export
  * @enum {string}
  */
export enum RetrieveLockboxesTypesEnum {
    UNKNOWN = 'UNKNOWN',
    INBOUND_TOA = 'INBOUND_TOA',
    OUTBOUND_TOA = 'OUTBOUND_TOA',
    RETURNED_CHECK = 'RETURNED_CHECK',
    CLAIM_REPAYMENT = 'CLAIM_REPAYMENT',
    BENEFICIARY = 'BENEFICIARY',
    HSA_FORM = 'HSA_FORM',
    MISTAKEN_DISTRIBUTION = 'MISTAKEN_DISTRIBUTION',
    HSA_ROLLOVER_FORM = 'HSA_ROLLOVER_FORM',
    HSA_CONTRIBUTION_FORM = 'HSA_CONTRIBUTION_FORM',
    HSA_TRANSFER_DIVORCE = 'HSA_TRANSFER_DIVORCE',
    HSA_ACCOUNT_CLOSURE = 'HSA_ACCOUNT_CLOSURE',
    COMBINE_HSA = 'COMBINE_HSA',
    DEATH_DISTRIBUTION = 'DEATH_DISTRIBUTION',
    POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
    RETURNED_MAIL = 'RETURNED_MAIL',
    EXCESS_CONTRIBUTION = 'EXCESS_CONTRIBUTION'
}
/**
  * @export
  * @enum {string}
  */
export enum RetrieveLockboxesStatusesEnum {
    NEW = 'NEW',
    PENDING = 'PENDING',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    INVESTMENTS_LIQUIDATED = 'INVESTMENTS_LIQUIDATED',
    CANCELED = 'CANCELED',
    DIVIDED = 'DIVIDED',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    PROCESSED_MANUALLY = 'PROCESSED_MANUALLY'
}
/**
  * @export
  * @enum {string}
  */
export enum RetrieveLockboxesPaymentMethodsEnum {
    CHECK = 'CHECK',
    WIRE = 'WIRE'
}
/**
  * @export
  * @enum {string}
  */
export enum RetrieveLockboxesWireStatusesEnum {
    SENT = 'SENT',
    NOT_SENT = 'NOT_SENT'
}
